import { ActivatedRoute } from '@angular/router';
import { TabsContainerService, BaseTabsContainer, UserService } from 'yt-ng-framework';
import { Component, OnInit } from '@angular/core';
import { KursDokument } from './kurs-dokument';

@Component({
    selector: 'yt-kurs-dokument-tabs',
    templateUrl: './kurs-dokument-tabs.component.html',
    providers: [
        TabsContainerService
    ]
})
export class KursDokumentTabsComponent extends BaseTabsContainer<KursDokument> implements OnInit {

    constructor(
      public tabsContainerService: TabsContainerService<KursDokument>,
      protected activatedRoute: ActivatedRoute,
      protected userService: UserService
    ) {
      super(tabsContainerService, activatedRoute, userService);
     }
  
    ngOnInit() {
      super.ngOnInit();
    }  
  }